// ============================================================================
// Vendors Swiper — continuous logo marquee, pause on hover
// ============================================================================
(function ($) {
    'use strict';

    $(function () {
        if (typeof Swiper === 'undefined') return;

        const els = document.querySelectorAll('[data-vendors-swiper]');
        if (!els.length) return;

        els.forEach(function (el) {
            new Swiper(el, {
                slidesPerView: 'auto',
                spaceBetween: 60,
                loop: true,
                speed: 4000,
                allowTouchMove: true,
                grabCursor: true,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },
                breakpoints: {
                    0:    { spaceBetween: 24 },
                    576:  { spaceBetween: 36 },
                    992:  { spaceBetween: 48 },
                    1280: { spaceBetween: 60 }
                }
            });
        });
    });
})(jQuery);
